export const TIMELINE_TABLE_DATA_INDICES = {
	CHANGE_TYPE: 'changeType',
	DISPLAY_NAME: 'displayName',
	LAST_MODIFIED_BY_NAME: 'lastModifiedByName',
	SONAR_OBJECT_TYPE: 'sonarObjectType'
};
